import { render } from "./WaveSection.vue?vue&type=template&id=037fe54e"
import script from "./WaveSection.vue?vue&type=script&lang=js"
export * from "./WaveSection.vue?vue&type=script&lang=js"

import "./WaveSection.vue?vue&type=style&index=0&id=037fe54e&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__